import { GoogleOAuthProvider } from '@react-oauth/google';
import AuftragMain from './AuftragMain';
import AuftragTerminieren from './AuftragTerminieren';
import { IAuftrag } from '../../types/Types';

/**
 * @author noone
 */
export type IAuftragTreminierenWrapperProps = {
    liste: IAuftrag[],
    statusChanged: () => void;
}
export default function AuftragMainWrapper(props: IAuftragTreminierenWrapperProps) {
    const google_clientid = process.env.REACT_APP_GOOGLE_CLIENTID!;

    return (
        <GoogleOAuthProvider clientId={google_clientid} >
            <AuftragTerminieren liste={props.liste} statusChanged={props.statusChanged} />
        </GoogleOAuthProvider>
    );

}

